import { Button, Result } from '@arco-design/web-react';
import { useNavigate } from 'react-router-dom';

/** 403 页（W5-1）：角色越权访问受角色路由矩阵保护的路径时展示 */
export default function Result403() {
  const navigate = useNavigate();
  return (
    <Result
      status="403"
      title="无权限访问"
      subTitle="当前角色没有访问该页面的权限，如有需要请联系管理员"
      style={{ paddingTop: 120 }}
      extra={
        <Button type="primary" onClick={() => navigate('/dashboard', { replace: true })}>
          返回仪表盘
        </Button>
      }
    />
  );
}
